<template>
  <div class="home" >
    <header class="header">
      <div class="search-box flex" >
        <div class="car-type flex" @click="goSearch">
          <div class="car-type-box" :class="{'yellow-active' : searchForm.type === 2}" >黄牌</div>
          <div class="car-type-box" :class="{'blue-active' : searchForm.type === 1}" >蓝牌</div>
        </div>
        <div class="input-search flex" @click="goSearch">
          <input :value="vno || ''" style="color: #000000" disabled placeholder="请输入货车车牌号" type="text">
        </div>
        <div class="operation flex" @click.stop="againSearch">
          <icon-search-svg></icon-search-svg>
        </div>
      </div>
      <div class="Example" v-if="!isLogin">
        <div  @click="setExampleCarLocation">沪BA8888（示例）</div>
      </div>
    </header>
    <div id="map" ></div>
    <div class="ticket-box" v-if="isLogin">
      <div class="ticket"  @click="showticketDetail">
        <div class="title">票</div>
        <div class="number">{{ticketTotal || 0}}</div>
      </div>
      <div class="month-card" @click="showMonthNumTipDialog">
        <div class="title">月卡</div>
        <div class="number">{{monthCardNum || 0}}</div>
      </div>
    </div>
    <votes-detail-dialog   ref="VotesDetailDialog"></votes-detail-dialog>
    <off-line-reason-dialog ref="OffLineReasonDialog"></off-line-reason-dialog>
    <first-search-car-dialog @agree="agreeBtn" ref="FirstSearchCarDialog"></first-search-car-dialog>
    <shield-search-car-dialog ref="ShieldSearchCarDialog"></shield-search-car-dialog>
    <tip-dialog
      ref="TipDialog"
      :message="tipMessage"
      :btntext="tipBtnText"
      @define='tipDefineBtn'
      title='提示'>
    </tip-dialog>
    <not-login  ref="NotLogin"></not-login>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import VotesDetailDialog from '../../components/VotesDetailDialog/index' // 票数详情解释说明弹框
import OffLineReasonDialog from '../../components/dialog/OffLineReasonDialog' // 车辆离线原因弹框
import FirstSearchCarDialog from '../../components/dialog/FirstSearchCarDialog' // 第一次查车弹框
import ShieldSearchCarDialog from '../../components/dialog/ShieldSearchCarDialog' // 黑名单或者未开启查车弹框
import TipDialog from '../../components/dialog/TipDialog' // 查询不到问题
import iconCar from '../../assets/images/search/xhp_position_truck_image@2x.png'
import iconClose from '../../assets/images/search/xhp_paopao_exit@2x.png'
import iconIndicate from '../../assets/images/search/xhp_map_paopao_arrow@2x.png'
import IconSearchSvg from '../../components//svg/IconSearchSvg'
import { gcj02tobd09, wgs84togcj02, direction } from '../../utils/map'
import { searchCarvclNs } from '../../api/searchCar'
import { isFirstSearchCar, addFirstQueryRecord } from '../../api/utilApi'
import { censusAnalyse } from '../../api/index'
// import { exposureUv } from '../../api/elevenActivity'
import { getUrlParam, getItem } from '../../utils'
import { searchCarCode } from '../../utils/searchCarUtil'
import { ttNavigateTo } from '../../utils/ByteDanceUtil'

export default {
  props: {},
  data () {
    return {
      searchForm: {
        type: 2, // 1为蓝牌 2为黄牌
        vclNo: '' // 车牌号
      },
      map: null, // 地图
      point: null, // 地图中心点
      carData: {}, // 查询的车的信息
      ticketBoxTop: '10px',
      tipMessage: '',
      loginDialog: false, // 登录弹框
      tipBtnText: '确定',
      timerUserShop: null
    };
  },
  computed: {
    ...mapGetters({
      isVip: 'isVip',
      vno: 'hisTrack/vno',
      monthCardNum: 'monthCardNum',
      ticketTotal: 'ticketTotal',
      getQueryParam: 'hisTrack/getQueryParam',
      platform: 'platform'
    }),
  },
  created () {},
  mounted () {
    this.$store.dispatch('refresh_user_shop_info')
    this.createMap()
    const type = getUrlParam('type')
    if (type) {
      this.searchForm.type = Number(type)
    }
    // 设置定时器更新用户票数
    const sessionId = getItem('sessionid')
    // 设置定时器更新用户票数
    if (sessionId && sessionId !== 'null') {
      clearInterval(this.timerUserShop)
      this.timerUserShop = setInterval(() => {
        this.$store.dispatch('refresh_user_shop_info')
      }, 3000)
    }
  },
  watch: {},
  methods: {
    ...mapMutations(['REFRESH_USER_PLATFORM']),

    createMap () {
      let map = new BMap.Map('map') // 创建地图实例
      this.point = new BMap.Point(116.4, 39.91) // 创建点坐标
      map.centerAndZoom(this.point, 12)
      this.map = map
      this.setvclNo()
    },

    /**
     * 设置卡车位置
    */
    setCarLoction (point) {
      const deviceSize = new BMap.Size(20, 67)
      const carIcon = new BMap.Icon(iconCar , deviceSize, {
        imageSize: deviceSize
      })
      const { carline, carupdateDate, spd, direction, adr, drc } = this.carData
      console.log(this.carData, point)
      const markerCar = new BMap.Marker(point, {icon: carIcon, rotation: drc})
      this.map.addOverlay(markerCar)
      const opts = {
        boxStyle:{
          opacity: '1',
          background: '#ffffff',
          width: '290px',
          height: '200px',
          marginBottom: '80px'
        },
        closeIconUrl: iconClose,
        closeIconMargin: '6px'
      }
      const vnoBackColor = this.searchForm.type === 2 ? '#FFCC23' : '#5572FD'
      const carlineTitle = carline ? '离线' : '在线'
      const listyle = 'color:#989898;padding-bottom:6px'
      const timediv = carline ? `<span style='color:#FC3435'>${carupdateDate}</span>` : `<span style='color:#1B1B20'>${carupdateDate}</span>`
      const statediv = carline ? `<div style='background-color: ${vnoBackColor};width:90px;
            height:20px;line-height:20px;text-align:center;border:2px solid #282828;color:#282828'  
            id='vnoinfo'>
            ${this.carData.vno}
          </div><div id='seeReason' style='color:#5572FD;text-decoration:underline;padding-left:20px'>查看原因</div>` : `<div style='background-color: #FFCC23;width:90px;
            height:20px;line-height:20px;text-align:center;border:2px solid #282828;color:#282828'  
            >
            ${this.carData.vno}
          </div>`
      const carContent = `<div style='padding: 10px 20px;
        background-color: #ffffff;
        '>
          <div style='display:flex;align-items: center;'>${statediv}</div>  
          <ul style='padding-top:10px;font-size: 14px'>
            <li style='${listyle}'>
              车辆状态： <span style='color:#1B1B20'>${carlineTitle}</span>
            </li>
            <li style='${listyle}'>
              最后更新： ${timediv}
            </li>
            <li style='${listyle}'>
              当前车速： <span style='color:#1B1B20'>${spd}km/h</span>
            </li>
            <li style='${listyle}'>
              行驶方向： <span style='color:#1B1B20'>${direction}</span>
            </li>
            <li style='${listyle}'>
              位置方向：<span style='color:#1B1B20'>${adr}</span>
            </li>
          </ul> 
        </div>
        <div style='text-align: center;;'><img style='width:50px' src='${iconIndicate}' /></div>`
      const carInfo = new BMapLib.InfoBox(this.map, carContent ,opts)
      carInfo.open(markerCar)
      markerCar.addEventListener('click', () => {
        carInfo.open(markerCar)
      })
      carInfo.addEventListener('open', () => {
        const closeImg = document.getElementsByClassName('infoBox')[0].getElementsByTagName('img')[0]
        closeImg.style.width = '20px'
        closeImg.addEventListener('touchend', () => {
          carInfo.close()
        })
        const seeReason = document.getElementById('seeReason')
        if (seeReason) {
          seeReason.addEventListener('touchend', () => {
            this.$refs.OffLineReasonDialog.showPopup()
          })
        }
      })
      // viewReasons.addEventListener('click', () => {
      //   console.log(true)
      // })
      this.map.centerAndZoom(this.point, 17)
    },

    /**
     * 获取卡车位置
    */
    async getCarLoction () {
      const param = [{
        vclNs: this.vno,
        color: this.searchForm.type
      }]
      const response = await searchCarvclNs(param)
      this.$store.dispatch('refresh_user_shop_info')
      if (response) {
        const { code, data,  } = response
        if (code === 10000) {
          const { reusltList } = data
          if (reusltList && reusltList.length) {
            this.carData = reusltList[0]
            const { lat, lon } = this.carData
            const lng = lon
            const gcj02 = wgs84togcj02( Number(lng) / 600000, Number(lat) / 600000)
            const maplng = gcj02tobd09(gcj02.lng, gcj02.lat).lng
            const maplat = gcj02tobd09(gcj02.lng, gcj02.lat).lat
            this.point = new BMap.Point(maplat, maplng + 0.002)
            const point = new BMap.Point(maplat, maplng)
            const currentDate = moment().format('YYYY-MM-DD HH:mm:ss') // 当前系统时间
            const carupdateDate = moment(Number(this.carData.utc)).format('YYYY-MM-DD HH:mm:ss') // 车辆最后更新时间
            const timeDifference = moment(currentDate).diff(moment(carupdateDate), 'minute')
            this.carData.carline = timeDifference > 60 ? true : false // 车辆状态是否在线 大于60离线
            this.carData.carupdateDate = carupdateDate
            this.carData.direction = direction(Number(this.carData.drc)) // 设置车辆方向
            this.setCarLoction(point)
          }
        } else if (code === 70001) {
          this.$refs.ShieldSearchCarDialog.showPopup()
        } else {
          this.tipMessage = searchCarCode(code)
          this.$refs.TipDialog.showPopup()
        }
        await censusAnalyse({
          eventFlag: 'truck_location',
          param: {
            vno: this.vno,
            hasSuccess: code === 10000 ? 1 : 0
          }
        })
      }
    },

    /**
     * 设置车牌号
    */
    setvclNo () {
      // 用户要搜索的车牌号
      if (getUrlParam('vno')) {
        const vno = decodeURIComponent(getUrlParam('vno'))
        this.searchForm.type = Number(decodeURIComponent(getUrlParam('type'))) || 1
        // 设置查车uv
        this.setCensusUv(92)
        if (vno) {
          this.$store.dispatch('hisTrack/setQueryParam', { vno })
          this.isFirstSearchCarGet()
        }
      }
    },

    /**
     * 显示票数详情
    */
    showticketDetail () {
      this.$refs.VotesDetailDialog.showPopup()
    },

    /**
     * 判断是否是第一次查询车牌号
    */
    async isFirstSearchCarGet () {
      const param = [{ vclNs: this.vno }]
      const response = await isFirstSearchCar(param)
      if (response) {
        const { code, data } = response
        if (code === 10000 && data.length) {
          this.$refs.FirstSearchCarDialog.showPopup()
          this.addSearchCarHistory(this.vno)
        } else {
          await this.getCarLoction()
        }
      }
    },

    /**
     * 如果用户是第一次查车，增加历史记录
    */
    async addSearchCarHistory (vnos) {
      const response = await addFirstQueryRecord({vnos})
      console.log(response, '增加历史记录')
    },

    /**
     * 首次查的车牌号确认事件
    */
    agreeBtn () {
      this.getCarLoction()
    },

    /**
     * 显示未登录弹窗
    */
    showNotLogin () {
      this.$refs.NotLogin.showPopup()
    },

    /**
     * 重新搜索
    */

    againSearch () {
      if (this.vno) {
        this.map.clearOverlays()
        this.setvclNo()
      } else {
        this.goSearch()
      }
    },

    /**
     * 去车辆搜索页面
    */
    goSearch () {
      if (!this.isLogin) {
        this.showNotLogin()
        return
      }
      if (this.ticketTotal === 0) {
        if (this.isQQ || this.isBytedance) {
          this.tipMessage = '您的票数余额为零，请至货车定位APP充值后继续查询'
          this.tipBtnText = '下载APP'
        }
        this.$refs.TipDialog.showPopup()
        return
      }
      const params = `?vno=${this.vno}&type=${this.searchForm.type}`
      if (this.isQQ) {
        qq.miniProgram.navigateTo ({
          url: `../home/searchCar/index${params}`
        });
      } else if(this.isBytedance) {
        ttNavigateTo(`/pages/home/searchCar/index${params}`)
      }
    },
    /**
     *
     * 设置示例车牌的位置
    */
    setExampleCarLocation() {
      this.carData = {
        adr: '上海市浦东新区江东路518号上海华宇货运有限公司,西南方向,254.3米',
        city: '上海市',
        country: '浦东新区',
        drc: '0',
        hasSubscribe: false,
        lat: '18823438',
        lon: '72910126',
        monthCard: 0,
        province: '上海市',
        spd: '0.0',
        state: 1001,
        subscribe: null,
        utc: new Date().getTime(),
        vco: '2',
        vno: '沪BA8888',
        carupdateDate: moment().format('YYYY-MM-DD HH:mm:ss'),
        vnoAndColor: '沪BA8888_2',
        carline: false,
        direction: '正北'
      }
      const { lat, lon } = this.carData
      const lng = lon
      const gcj02 = wgs84togcj02( Number(lng) / 600000, Number(lat) / 600000)
      const maplng = gcj02tobd09(gcj02.lng, gcj02.lat).lng
      const maplat = gcj02tobd09(gcj02.lng, gcj02.lat).lat
      const point = new BMap.Point(maplat, maplng)
      this.point = new BMap.Point(maplat, maplng + 0.002)
      this.setCarLoction(point)
    },

    /**
     *
     *
     * 确定弹框确定事件
    */
    tipDefineBtn () {
      if (this.tipBtnText === '下载APP') {
        if (this.isQQ) {
          // qq小程序
          qq.miniProgram.navigateTo ({
            url: '/pages/personalCenter/downloadApp/index'
          })
        } else if(this.isBytedance) {
          // 字节跳动小程序
          ttNavigateTo('/pages/personalCenter/downloadApp/index')
        }
      }
    },
    /**
     *
     * 点击月卡事件
    */
    showMonthNumTipDialog () {
      if ((this.isQQ || this.isBytedance) && this.monthCardNum === 0) {
        this.tipMessage = '请至货车定位APP购买月卡'
        this.tipBtnText = '下载APP'
        this.$refs.TipDialog.showPopup()
        return
      }
    },
    /**
     *
     *
     * 添加轨迹查询uv
    */
    // async setCensusUv(type) {
    //   await exposureUv(type)
    // },
  },
  components: {
    VotesDetailDialog,
    OffLineReasonDialog,
    FirstSearchCarDialog,
    ShieldSearchCarDialog,
    TipDialog,
    IconSearchSvg
  }
};
</script>

<style scoped lang="scss">

.home {
  width: 100%;
  height: 100%;
  overflow:hidden;
  position: relative;
  .flex {
    display: flex;
  }
  #map {
    width: 100%;
    height: calc(100vh - 45px);
    overflow-y: hidden;
  }
  #map>:nth-child(4) {
    display: none;
  }
  .header {
    width: 100%;
    background-color: #ffffff;
    padding: 10px 20px;
    left: 0;
    top: 0;
    .search-box {
      justify-content: space-between;
      width: 100%;
    }
    .Example {
      border-top: 1px solid #cccccc;
      margin-top: 20px;
      width: 95%;
      div {
        margin-top: 10px;
        width: 260px;
        background-color: #FFCC23;
        border: 4px solid #282828;
        color: #282828;
        font-size: 22px;
        text-align: center;
        border-radius: 4px;
        padding: 10px 10px;
      }
    }
    .car-type {
      // padding: 10px 20px;
      height: 60px;
      line-height: 60px;
      font-size: 26px;
      font-weight: 500;
      text-align: center;
      width: 180px;
      background: rgba(229,229,229,1);
      border-radius: 6px 6px 3px;
      z-index: 99;
      .car-type-box {
        flex: 1;
        height: 60px;
        text-align: center;
        color: #656565;
      }
      .yellow-active {
        background: rgba(247,201,68,1);
        box-shadow: 2px 0 4px 0 rgba(176,176,176,.74);
        border-radius: 6px;
      }
      .blue-active {
        background: rgba(85,114,253,1);
        box-shadow: 2px 0 4px 0 rgba(176,176,176,.74);
        border-radius: 6px;
        color: #ffffff;
      }
    }
    .input-search {
      flex: 1;
      padding: 0 40px;
      align-items: center;
      input {
        font-size: 28px;
        height: 40px;
        line-height: 40px;
        color: #282828;
        width: 100%;
        background-color: #ffffff;
      }
      input::-webkit-input-placeholder {
        color: #CCCCCC;
        -webkit-text-fill-color: #CCCCCC;
        -webkit-opacity:1;
        opacity: 1;
      }
      input[disabled] {
        color: #282828;
        -webkit-text-fill-color:#282828;
        -webkit-text-fill-color:#282828;
        -webkit-opacity:1;
        opacity: 1;
      }
    }
    .operation {
      position: relative;
      width: 84px;
      align-items: center;
    }
  }
  .ticket-box {
    position: absolute;
    top: 110px;
    right: 30px;
    padding: 10px 10px;
    font-size: 24px;
    text-align: center;
    background-color: #ffffff;
    .ticket {
      margin-bottom: 10px;
      padding-bottom: 10px;
      .title {
        background-color: #FEDA74;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        text-align: center;
        line-height: 50px;
      }
      border-bottom: 1px solid #CCCCCC;
    }
    .month-card {
      .title {
        background-color: #7FBCFF;
        border-radius: 4px;
      }
    }
    .title {
      color: #ffffff
    }
    .number {
      padding-top: 10px;
    }
  }
  .car-message {
    position: absolute;
    padding: 20px 20px;
    background-color: #ffffff;
    width: 500px;
    height: 100px;
    z-index: 99;
    margin: 0 auto;
    left: 50%;
    top: 50%;
    margin-left: -250px;
    margin-top: -200px;
    // margin-top: -60vh;
  }
}
</style>
